import type { NativeToken } from '@shared/types/native-token.types'

const STATUSES = ['active', 'active', 'active', 'active', 'inactive', 'suspended', 'revoked', 'expired'] as const
const CARD_BRANDS = ['Visa', 'Mastercard', 'Amex', 'Discover'] as const
const MERCHANTS = [
  { id: 'mch_001', name: 'Acme Corp' },
  { id: 'mch_002', name: 'TechFlow Inc' },
  { id: 'mch_003', name: 'Global Retail' },
  { id: 'mch_004', name: 'FastPay Services' },
  { id: 'mch_005', name: 'Digital Commerce' },
  { id: 'mch_006', name: 'ShopSmart Ltd' },
  { id: 'mch_007', name: 'PayEase Solutions' },
  { id: 'mch_008', name: 'Horizon Payments' },
]

function randomItem<T>(arr: readonly T[]): T {
  return arr[Math.floor(Math.random() * arr.length)]
}

function randomLast4(): string {
  return String(Math.floor(1000 + Math.random() * 9000))
}

function randomDate(daysBack: number): string {
  const date = new Date()
  date.setDate(date.getDate() - Math.floor(Math.random() * daysBack))
  return date.toISOString()
}

function randomExpiry(): string {
  const month = String(Math.floor(1 + Math.random() * 12)).padStart(2, '0')
  const year = 2025 + Math.floor(Math.random() * 5)
  return `${month}/${year}`
}

function randomTokenRef(): string {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789'
  let ref = 'tok_'
  for (let i = 0; i < 16; i++) {
    ref += chars[Math.floor(Math.random() * chars.length)]
  }
  return ref
}

export const mockNativeTokens: NativeToken[] = Array.from({ length: 64 }, (_, i) => {
  const merchant = randomItem(MERCHANTS)
  return {
    id: `ntv_${String(i + 1).padStart(4, '0')}`,
    status: randomItem(STATUSES),
    tokenReference: randomTokenRef(),
    merchantId: merchant.id,
    merchantName: merchant.name,
    cardLast4: randomLast4(),
    cardBrand: randomItem(CARD_BRANDS),
    tokenCreated: randomDate(365),
    tokenExpiry: randomExpiry(),
    lastUsed: randomDate(30),
    usageCount: Math.floor(Math.random() * 500),
  }
})
